import type { FrameworkSnapshot } from "@apf/framework-config";

/**
 * Route definitions in a resolved snapshot are an allowlist, not only a source
 * for navigation labels. Detail routes inherit the permission of their static
 * parent, which is supplied explicitly by each router declaration.
 */
export function isProjectedRouteAllowed(snapshot: FrameworkSnapshot, parentPath: string): boolean {
  return snapshot.content.routes.some((route) => route.path === parentPath);
}
